var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('VerticalMenuView',{attrs:{"drawer":_vm.$root.drawer,"menu":_vm.menu}}),_c('HeaderView',{attrs:{"drawer":_vm.drawer,"notifications":_vm.notifications}}),_c('BodyView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }